module.exports = __webpack_public_path__ + "static/media/16.6b9b5007.jpg";